module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai75-cc1f2763659960456443d36c9ab0097a.jpg";